import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-quotationoptions',
    templateUrl: './quotationoptions.component.html',
    styleUrls: ['./quotationoptions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class QuotationoptionsComponent {

}
